/**
 * Hill-Langmuir receptor occupancy: the fraction of receptors bound at a
 * given free ligand concentration, assuming simple bimolecular binding
 * (Hill coefficient of 1, the standard default absent specific cooperativity
 * data for a given receptor-ligand pair).
 *
 * occupancy = C^n / (C^n + Ki^n)
 *
 * Defining property: occupancy(C = Ki) = 0.5 exactly.
 */
export function hillLangmuirOccupancy(concentrationNM: number, kiNM: number, hillCoefficient = 1): number {
  if (concentrationNM <= 0) return 0;
  if (kiNM <= 0) throw new Error('kiNM must be positive');

  const cN = concentrationNM ** hillCoefficient;
  const kiN = kiNM ** hillCoefficient;
  const occupancy = cN / (cN + kiN);

  return Math.min(1, Math.max(0, occupancy));
}
